import MemberHeaderMobile from './member-header-mobile';
import MemberHeaderDesktop from './member-header-desktop';
import forDevice from '../../hoc/for-device';

export default forDevice(MemberHeaderMobile, MemberHeaderDesktop);



// WEBPACK FOOTER //
// ./app/components/member-header/member-header.js